export default {
    'general': {
        'versioning': 'Versioning',
        'dashboard': 'Dashboard',
        'email': 'Email',
        'username': 'Username',
        'name': 'Name',
        'password': 'Password',
        'actions': 'Actions',
        'login': 'Login',
        'logout': 'Logout',
        'no_results': 'No results',
        'success': 'Success',
        'warning': 'Warning',
        'remember_me': 'Remember me',
        'error': 'Error',
        'edit': 'Edit',
        'details': 'Details',
        'add': 'Add',
        'delete': 'Delete',
        'yes': 'Yes',
        'no': 'No',
        'cancel': 'Cancel',
        'back': 'Back',
        'image': 'Image',
        'filters': 'Filters',
        'remove_filters': 'Remove filters',
        'default': 'Default',
        'save': 'Save',
        'key': 'Key',
        'distribution_zone': 'Distribution zone',
        'preview': 'Preview',
        'icon': 'Icon',
        'last_edited': 'Last edited',
        'unknown': 'Unknown',
        'latest_version': 'Latest version',
        'change': 'Change'
    },
    'errors': {
        'generic_error': 'There was an error',
        'login': 'There was an error logging in',
        'logout': 'There was an error logging out',
        'incorrect_password': 'The old password is incorrect',
        'invalid_data': 'Invalid data received',
        'not_found': 'Data not found',
        'user_exist': 'User with this email already exists',
        'load_data': 'There was an error loading data',
        'on_upload_image': 'There was an error uploading images',
        'on_upload_file': 'There was an error uploading files',
        'on_publish': 'There was an error while publishing',
        'on_approve': 'There was an error while approving',
        'on_download': 'There was an error while downloading file',
        'on_add': 'There was an error adding',
        'on_edit': 'There was an error editing',
        'on_delete': 'There was an error deleting',
        'on_sort': 'There was an error sorting',
        'unauthorized': 'Unauthorized',
        'user_does_not_exist': 'User does not exists',
        'username_exists': 'This username already exists. Please use different username.',
        'email_exists': 'This email already exists. Please use different email.',
        'failed_to_insert': 'Failed to insert',
        'file_to_big': 'File is to big',
        'missing_roles': 'Missing roles',
        'no_roles_selected': 'User must have at least one role selected',
        'fetching_data': 'Error fetching data',
        'deleting_default_data': 'Error deleting default data',
        'data_already_exists': 'Data already exists',
        'unable_to_retrieve_extension': 'Unable to retrieve extension',
        'role_exists': 'Role exists',
        'role_does_not_exist': 'role does not exists',
        'time_parser': {
            'invalid_character_error': 'Only numbers and {0} units are allowed.',
            'number': 'number',
            'unit': 'unit',
            'invalid_format_error': 'Units must be in form of',
            'duplicated_unit_error': 'The unit {0} is duplicated.',
            'example': '(example: 3d12h)'
        },
        'max_queue_time': 'Max time for queue excided. Please use shorter duration.',
        'queue_time_to_small': 'Queue time is to short. Use longer duration.'
    },
    'success': {
        'on_add': 'Successfully added',
        'on_edit': 'Successfully edited',
        'on_delete': 'Successfully deleted',
        'on_publish': 'Successfully published',
        'on_approve': 'Successfully approved',
        'on_sort': 'Successfully sorted',
        'on_change_password': 'The password has been successfully changed',
        'channel_package_activated': 'Channel package successfully activated',
        'channel_package_deactivated': 'Channel package successfully deactivated'
    },
    'confirmations': {
        'general': 'Are you sure you want to proceed?',
        'header': 'Are you sure',
        'delete_row': 'Are you sure you want to delete',
        'deactivate_row': 'Are you sure you want to deactivate',
        'publish': 'Are you sure you want to publish on',
        'approve': 'Are you sure you want to approve'
    },
    'table': {
        'no_data': 'No data to display',
        'press_enter_search': 'Press enter to search',
        'search': 'Search by',
        'select_option': 'Select option',
        'select_date': 'Select date',
        'select_range': 'Select range',
        'of': 'of'
    },
    'file': {
        'drag_and_drop': 'Drag and drop files to here to upload.'
    },
    'language': {
        'slovenian': 'Slovenian',
        'english': 'English',
        'croatian': 'Croatian'
    },
    'reseller': {
        'reseller': 'Reseller',
        'resellers': 'Resellers',
        'friendly_name': 'Friendly name',
        'company_name': 'Company name',
        'tax_number': 'Tax number',
        'address': 'Address',
        'queue_time': 'Queue time',
        'max_unauthorised_discount': 'Max discount',
        'country_code': 'Country code',
        'edit': 'Edit reseller',
        'add': 'Add reseller',
        'delete': 'This will also delete all sellers.',
        'created_at': 'Created',
        'last_edited_at': 'Last edited'
    },
    'countries': {
        'slovenia': 'Slovenia',
        'croatia': 'Croatia',
        'bosnia_and_herzegovina': 'Bosnia and Herzegovina',
        'austria': 'Austria',
        'italy': 'Italy',
        'hungary': 'Hungary',
        'serbia': 'Serbia'
    },
    'pos_hardware': {
        'pos_hardware': 'POS Hardware',
        'add': 'Add POS Hardware',
        'edit': 'Edit POS Hardware',
        'price': 'Price',
        'vat': 'VAT',
        'max_discount': 'Max discount'
    },
    'user': {
        'user': 'User | Users',
        'add': 'Add user',
        'edit': 'Edit user',
        'first_name': 'First name',
        'last_name': 'Last name',
        'email': 'Email',
        'password': 'Password',
        'confirm_password': 'Confirm password',
        'roles': 'Roles',
        'cannot_edit_email': 'Email cannot be edited',
        'change_password': 'Change password',
        'new_password': 'New password'
    },
    'role': {
        'admin': 'Admin',
        'user': 'User'
    },
    'profile': {
        'profile': 'Profile',
        'edit_profile': 'Edit profile',
        'old_password': 'Old password',
        'new_password': 'New password',
        'confirm_password': 'Confirm password',
        'change_password_text': 'If password field is empty, password will not be changed.',
        'change_password': 'Change password'
    },
    'seller': {
        'seller': 'Seller | Sellers',
        'add': 'Add seller',
        'edit': 'Edit edit',
        'first_name': 'First name',
        'last_name': 'Last name',
        'email': 'Email',
        'phone_number': 'Phone number',
        'language': 'Language',
        'password': 'Password',
        'change_password': 'Change password',
        'new_password': 'New password',
        'confirm_password': 'Confirm password',
        'role': {
            'role': 'Role | Roles',
            'view_all_leads': 'View all leads',
            'reassign_leads': 'Reassign leads',
            'remove_leads': 'Remove leads',
            'manage_users': 'Manage users'
        }
    },
    'current_software': {
        'current_software': 'Current software | Current software',
        'add': 'Add current software',
        'edit': 'Edit current software',
        'color': 'Color'
    },
    'lead_source': {
        'lead_source': 'Lead source | Lead sources',
        'add': 'Add lead source',
        'edit': 'Edit lead source'
    },
    'equipment': {
        'card_payment_equipment': 'Card payment equipment | Card payment equipments',
        'add_card_payment_equipment': 'Add card payment equipment',
        'edit_card_payment_equipment': 'Edit card payment equipment',
        'color': 'Color',
        'monthly_price': 'Monthly price',
        'one_time_price': 'One time price',
        'bought': 'Bought',
        'not_bought': 'Not bought',
        'provider_name': 'Provider name'
    }
}
